import type { QueryKey, UndefinedInitialDataInfiniteOptions, UndefinedInitialDataOptions, UseQueryOptions } from '@tanstack/react-query';

/**
 * Partial type for overriding query options
 * use UndefinedInitialDataOptions to allow undefined initial data
 */
export type QueryOptionsOverride<TQueryFnData = unknown, TError = Error, TData = TQueryFnData>
  = Omit<
    Partial<UndefinedInitialDataOptions<TQueryFnData, TError, TData>>,
    'queryKey' | 'queryFn'
  >;

/**
 * Partial type for overriding infinite query options
 * use UndefinedInitialDataInfiniteOptions to allow undefined initial data
 */
export type InfiniteQueryOptionsOverride<TQueryFnData = unknown, TError = Error, TData = TQueryFnData, TPageParam = number>
  = Omit<
    Partial<UndefinedInitialDataInfiniteOptions<TQueryFnData, TError, TData, QueryKey, TPageParam>>,
    'queryKey' | 'queryFn'
  >;

export type QueryBehaviorOptions<TQueryFnData, TData = TQueryFnData> = Pick<
  UseQueryOptions<TQueryFnData, Error, TData>,
  | 'enabled'
  | 'select'
  | 'staleTime'
  | 'gcTime'
  | 'refetchOnWindowFocus'
>;

export const PUBLIC_QUERY_STALE_TIME = Infinity;
